window.jQuery = window.$ = require('jquery');

import angular from 'angular';
import ngResource from 'angular-resource';
import ngRoute from 'angular-route';
import ngCookie from 'angular-cookies';
import ngAnimate from 'angular-animate';
import ngMessages from 'angular-messages';
import ngLadda from 'angular-ladda';
import ngSanitize from 'angular-sanitize';
import ngLocalStorage from 'angular-local-storage';
import Components from './components/components';
import CommonComponents from './common/components.common';
import Services from './services/services';
import Directives from './directives/directives'
import AppComponent from './app.component';
import uiBootstrap from 'angular-ui-bootstrap';
import postcodeAutocompleteTemplate from './common/postcode/postcode-autocomplete-template.html';
import PNotify from 'pnotify';
import PNotifyConfirm from '../../node_modules/pnotify/dist/pnotify.confirm';
import PNotifyButtons from '../../node_modules/pnotify/dist/pnotify.buttons';
import ngPNotify from 'angular-pnotify';

PNotify.prototype.options.styling = "fontawesome";

const MODULE_NAME = 'app';

angular.module(MODULE_NAME, [
    Components.name,
    CommonComponents.name,
    Services.name,
    Directives.name,
    ngResource,
    ngRoute,
    ngCookie,
    ngAnimate,
    ngMessages,
    ngLadda,
    ngSanitize,
    uiBootstrap,
    ngLocalStorage,
    'jlareau.pnotify'
])
.config(($locationProvider) => {
    "ngInject";
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: true
    }).hashPrefix('');
})
.config((localStorageServiceProvider) => {
    "ngInject";
    localStorageServiceProvider
        .setPrefix('trs-online-order')
        .setStorageCookie(0, '/>');
})
.config((notificationServiceProvider) => {
    "ngInject";

    var stack = {"dir1": "down", "dir2": "left", "firstpos1": 25, "firstpos2": getStackPos()};

    $(window).resize(function(){
        stack.firstpos2 = getStackPos();
    });

    function getStackPos() {

        var firstpos2 = 'left';

        if($(window).width() < 768) {
            firstpos2 = ($(window).width() / 2) - (Number(PNotify.prototype.options.width.replace(/\D/g, '')) / 2);
        }

        return firstpos2;
    }

    notificationServiceProvider
        .setStack('custom_stack', 'stack-topright',  stack)
        .setDefaultStack('custom_stack');
})
.component('app', AppComponent)
.constant('environment', {
    USER_TYPE: window.userType ? window.userType : 'retail'
})
.constant('postcode', {
    POSTCODE_MIN_LENGTH_FOR_AUTOCOMPLETE: 3,
    POSTCODE_SEARCH_RESULTS_LIMIT: 8
})
.constant('storefinder', {
    STORE_FINDER_SEARCH_RESULTS_LIMIT: 6
})
.constant('product', {
    PRODUCT_MIN_QUANTITY: 1,
    PRODUCT_MAX_QUANTITY: 30000
})
.run(
    function($templateCache) {
        "ngInject";
        $templateCache.put('postcode-autocomplete-template.html', postcodeAutocompleteTemplate);
    }
).run(
    function($rootScope, cartService, $window, $rootElement) {
        "ngInject";

        $rootScope.$on('$routeChangeStart',
            function(event, toState, toParams, fromState, fromParams){
                angular.element($rootElement).removeClass("loaded");

                if(!cartService.canViewCart()) {
                    event.preventDefault();
                    $window.location.href = '/myaccount/home';
                }
            }
        );

        $rootScope.$on('$routeChangeSuccess',
            function(event, toState, toParams, fromState, fromParams){
                angular.element($rootElement).addClass("loaded");
            }
        );
    }
);



// WEBPACK FOOTER //
// ./src/app/entry.js